export default __webpack_public_path__ + "static/media/puzzle-piece.2f5e4d21.svg";